<template>
  <main class="auth-experience">
    <router-link to="/" class="auth-brand" aria-label="Voltar para a página inicial da Sanvault">
      <img src="../../assets/images/home/favicon.png" alt="">
      <span>Sanvault</span>
    </router-link>

    <section class="auth-value-panel">
      <div class="auth-value-panel__content">
        <span class="auth-kicker">Recuperação segura</span>
        <h1>Volte para sua operação em poucos passos.</h1>
        <p>
          Informe seu e-mail de acesso e enviaremos as orientações para recuperar
          sua conta com segurança.
        </p>
        <div class="auth-value-list">
          <span><i class="ph ph-envelope-simple"></i> Orientações enviadas por e-mail</span>
          <span><i class="ph ph-lock-key"></i> Processo protegido</span>
          <span><i class="ph ph-arrow-left"></i> Retorno simples para o login</span>
        </div>
      </div>
    </section>

    <section class="auth-form-panel" aria-label="Recuperação de senha">
      <ForgotPassword />
    </section>
  </main>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import ForgotPassword from "../../components/Authentication/ForgotPassword.vue";

export default defineComponent({
  name: "ForgotPasswordPage",
  components: {
    ForgotPassword,
  },
});
</script>
